<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-row>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Hệ đào tạo"
                    label-for="trainingSystemId"
                  >
                    <v-select
                      v-model="filter.trainingSystemId"
                      :options="trainingSystems"
                      :reduce="option => option.value"
                      @input="onTrainingSystemsChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Khóa học"
                    label-for="courseId"
                  >
                    <v-select
                      v-model="filter.courseId"
                      :options="courses"
                      :reduce="option => option.value"
                      @input="onCoursesChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Khoa/Bộ môn"
                    label-for="departmentId"
                  >
                    <v-select
                      v-model="filter.departmentId"
                      :options="departments"
                      :reduce="option => option.value"
                      @input="onDepartmentChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Ngành học"
                    label-for="majorId"
                  >
                    <v-select
                      v-model="filter.majorId"
                      :options="majors"
                      :reduce="option => option.value"
                      @input="onMajorChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Lớp cố định"
                    label-for="classId"
                  >
                    <v-select
                      v-model="classId"
                      :options="classes"
                      :reduce="option => option.value"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <div
                    class="text-right"
                    style="padding-top: 20px;"
                  >
                    <b-button
                      v-show="classId > 0 && updatable"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mr-1"
                      @click="onSetGraduation"
                    >
                      Xét duyệt
                    </b-button>
                    <b-button
                      v-show="classId > 0"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mr-1"
                      @click="onSelect"
                    >
                      Danh sách
                    </b-button>
                    <b-button
                      v-show="classId > 0"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      @click="exportExcel"
                    >
                      Xuất excel
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <b-row class="mt-2">
              <b-col cols="12">
                <div>
                  <vue-good-table
                    mode="remote"
                    :columns="columns"
                    :rows="dataLists"
                    :pagination-options="paginationOptions"
                    :line-numbers="true"
                    style-class="vgt-table condensed bordered"
                  >
                    <div
                      slot="emptystate"
                      style="text-align: center; font-weight: bold"
                    >
                      Không có bản ghi nào !
                    </div>
                    <template
                      slot="table-row"
                      slot-scope="props"
                    >
                      <span v-if="props.column.field === 'stt'">
                        {{ props.row.originalIndex + 1 }}
                      </span>
                      <span v-else-if="props.column.field === 'graduation_type'">
                        {{ getGraduationTypeStatus(props.row.graduation_type) }}
                      </span>
                      <span v-else-if="props.column.field === 'action'">
                        <b-button
                          v-if="updatable"
                          v-b-modal.revenueSaveModal
                          variant="primary"
                          class="btn-icon"
                          size="sm"
                          @click="onUpdate(props.row)"
                        >
                          <feather-icon icon="Edit2Icon"/>
                        </b-button>
                        <b-button
                          v-if="addGraduateDissertation && props.row.graduation_type === 2"
                          v-b-modal.revenueSaveModal
                          variant="success"
                          class="btn-icon"
                          size="sm"
                          style="margin-left: 6px"
                          @click="onAdd(props.row)"
                        >
                          <feather-icon icon="ListIcon"/>
                        </b-button>
                      </span>
                      <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    </template>
                  </vue-good-table>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <validation-observer
      ref="updateGraduationTypeFormRef"
      #default="{invalid}"
    >
      <b-modal
        v-if="updatable"
        id="updateGraduationTypeModal"
        ref="updateGraduationTypeModal"
        title="Cập nhật hình thức làm khóa luận"
        no-close-on-backdrop
      >
        <b-form-group label-for="trainingSystemId">
          <template v-slot:label>
            Hình thức làm khóa luận <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{errors}"
            name="Hình thức làm khóa luận"
            rules="required"
          >
            <v-select
              v-model="graduation_type_id"
              :options="graduationType"
              :reduce="option => option.value"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              :disabled="invalid"
              @click="onSave()"
            >
              <span class="text-right">
                <feather-icon icon="CheckIcon" /> Lưu
              </span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="$bvModal.hide('updateGraduationTypeModal')"
            >
              <span class="text-right">
                <feather-icon icon="XIcon" /> Hủy
              </span>
            </b-button>
          </div>
        </template>
      </b-modal>
    </validation-observer>
    <validation-observer
      ref="addGraduateDissertationRef"
      #default="{invalid}"
    >
      <b-modal
        v-if="addGraduateDissertation"
        id="addGraduateDissertationModal"
        ref="addGraduateDissertationModal"
        title="Thêm đề tài KLTN cho sinh viên"
        no-close-on-backdrop
      >
        <b-form-group label-for="graduateDissertationId">
          <template v-slot:label>
            Đề tài Khóa luận tốt nghiệp <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{errors}"
            name="Đề tài Khóa luận tốt nghiệp"
            rules="required"
          >
            <v-select
              v-model="graduateDissertationId"
              label="name"
              :options="registerDataSources"
              :reduce="option => option.id"
            />
            <b-form-invalid-feedback :state="getElementState(errors)">
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              :disabled="invalid"
              @click="onAddGraduateDissertation()"
            >
              <span class="text-right">
                <feather-icon icon="CheckIcon" /> Lưu
              </span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="$bvModal.hide('addGraduateDissertationModal')"
            >
              <span class="text-right">
                <feather-icon icon="XIcon" /> Hủy
              </span>
            </b-button>
          </div>
        </template>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BOverlay,
  BRow, BFormGroup, BForm, VBTooltip, BFormInvalidFeedback,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import * as XLSX from 'xlsx'

export default {
  name: 'CreditClass',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BCard,
    BCol,
    BContainer,
    BOverlay,
    BRow,
    BFormGroup,
    BForm,
    vSelect,
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      graduation_type_id: undefined,
      studentId: undefined,
      courseId: undefined,
      graduateDissertationId: undefined,
      selectedItem: undefined,
      filter: {
        currentPage: 1,
        itemsPerPage: 1000,
        organizationId: '',
        trainingSystemId: '',
        courseId: '',
        courseSemesterId: '',
        departmentId: '',
        majorId: '',
        programmeId: '',
        subjectId: '',
        status: '',
        sort: '',
      },
      classId: null,
      paginationOptions: {
        enabled: false,
      },
      columns: [
        {
          label: 'Mã sinh viên',
          field: 'student_code',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Họ và tên',
          field: 'full_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngày sinh',
          field: 'birthday',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Tích lũy hs 10',
          field: 'cgpa_tenth',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Hình thức làm khóa luận',
          field: 'graduation_type',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      dataLists: 'graduationCondition/dataLists',
      classes: 'graduationCondition/classes',
      courses: 'dropdown/courses',
      trainingSystems: 'dropdown/trainingSystems',
      departments: 'dropdown/departments',
      majors: 'dropdown/majors',
      graduationType: 'graduationCondition/graduationType',
      graduationTypeStatus: 'graduationCondition/graduationTypeStatus',
      registerDataSources: 'graduationCondition/registerDataSources',
      registeredDataSources: 'graduationCondition/registeredDataSources',
    }),
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.GRADUATION_CLASS)
    },
    addGraduateDissertation() {
      return hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.REGISTER_GRADUATION_DISSERTATION)
    },
  },
  async created() {
    this.isLoading = true
    try {
      const cUser = getUser()
      this.filter.organizationId = (cUser.orgId ? cUser.orgId : 0)
      await Promise.all([
        this.getTrainingSystems({ organizationId: this.filter.organizationId }),
        this.getDepartments({ organizationId: this.filter.organizationId }),
      ])
      if (this.trainingSystems.length > 0) {
        this.filter.trainingSystemId = this.trainingSystems[0].value
        await this.getCourses(this.filter)
      }
      this.$store.commit('graduationCondition/SET_DATA', { records: [] })
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      getData: 'graduationCondition/getData',
      getTrainingSystems: 'dropdown/getTrainingSystems',
      getCourses: 'dropdown/getCourses',
      getDepartments: 'dropdown/getDepartments',
      getMajors: 'dropdown/getMajors',
      getClasses: 'graduationCondition/getClasses',
      updateGraduationType: 'graduationCondition/updateGraduationType',
      setGraduationClass: 'graduationCondition/setGraduationClass',
      getDataGraduationProjectSources: 'graduationCondition/getDataGraduationProjectSources',
      createStudentRegisterSubject: 'graduationCondition/createStudentRegisterSubject',
      updateStudentRegisterSubject: 'graduationCondition/updateStudentRegisterSubject',
    }),
    async onTrainingSystemsChange(event) {
      this.filter.trainingSystemId = event
      this.filter.courseId = null
      await this.getCourses(this.filter)
    },
    async onCoursesChange(event) {
      this.filter.courseId = event
      this.filter.courseSemesterId = null
    },
    async onDepartmentChange(event) {
      this.filter.departmentId = event
      this.filter.majorId = null
      await this.getMajors(this.filter)
    },
    async onMajorChange(event) {
      this.filter.majorId = event
      this.filter.programmeId = null
      await this.getClasses(this.filter)
    },
    async onSelect() {
      this.isLoading = true
      try {
        await this.getData({
          class_id: this.classId,
        })
        if (this.dataLists.filter(item => item.graduation_condition_type === 2).length === 0) {
          this.checkUpdate = true
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    onUpdate(item) {
      this.selectedItem = item.student_class_id
      this.graduation_type_id = item.graduation_type
      this.$refs.updateGraduationTypeModal.show()
    },
    async onAdd(item) {
      this.selectedItem = item.student_class_id
      this.studentId = item.student_id
      this.courseId = item.course_id
      await this.getDataGraduationProjectSources({
        studentId: this.studentId,
        courseId: this.courseId
      })
      this.graduateDissertationId = this.registeredDataSources.length > 0 ? this.registeredDataSources[0].name : ''
      this.$refs.addGraduateDissertationModal.show()
    },
    async onSetGraduation() {
      try {
        await this.setGraduationClass({ class_id: this.classId })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Xét duyệt điều kiện làm khóa luận thành công!',
            icon: 'XCircleIcon',
            variant: 'success',
          },
        })
        await this.getData({
          class_id: this.classId,
        })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async onAddGraduateDissertation() {
      const checkUpdate = this.registeredDataSources.length > 0 ? true : false
      const valid = this.$refs
        .addGraduateDissertationRef
        .validate()
      this.isLoading = true
      if (valid) {
        try {
          const id = checkUpdate ? this.registeredDataSources[0].id : null
          const response = checkUpdate ? await this.updateStudentRegisterSubject({
            id: id,
            graduateDissertationId: this.graduateDissertationId,
            studentClassId: this.selectedItem,
          }): await this.createStudentRegisterSubject({
            graduateDissertationId: this.graduateDissertationId,
            studentClassId: this.selectedItem,
            status: 1
          })
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              this.$bvModal.hide('addGraduateDissertationModal')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
    async onSave() {
      const valid = this.$refs
        .updateGraduationTypeFormRef
        .validate()
      if (valid) {
        try {
          await this.updateGraduationType({ student_class_id: this.selectedItem, graduation_type: this.graduation_type_id })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cập nhật hình thức làm khóa luận thành công!',
              icon: 'XCircleIcon',
              variant: 'success',
            },
          })
          this.graduation_type_id = undefined
          await this.getData({
            class_id: this.classId,
          })
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.$bvModal.hide('updateGraduationTypeModal')
        }
      }
    },
    getGraduationTypeStatus(id) {
      const status = this.graduationTypeStatus.find(status => status.value === id);
      return status ? status.label : '';
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    exportExcel() {
      if (this.dataLists.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Không có dữ liệu để xuất!',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }
      const data = []
      const header = {}
      this.columns.forEach(column => {
        header[column.field] = column.label
      })
      const headerKeys = Object.keys(header)
      const dataSourceKeys = Object.keys(this.dataLists[0])
      const duplicates = dataSourceKeys.filter(val => headerKeys.includes(val))
      duplicates.sort((a, b) => headerKeys.indexOf(a) - headerKeys.indexOf(b))
      this.dataLists.forEach(dataSource => {
        const elm = {}
        duplicates.forEach(key => {
          elm[header[key]] = dataSource[key]
        })
        data.push(elm)
      })
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'SinhVien')
      XLSX.writeFile(wb, 'DanhSachXetDuyetLamKhoaLuan.xlsx')
    },
  },
}
</script>
